export default _this => {
  _this.columns = [
    "qrcode",
    "time",
    "client",
    "model",
    "ip",
    "printer",
    "scanner",
    "clients",
    "jobs",
    "total",
    "black",
    "color",
    "prints",
    "copies",
    "scans",
    "income"
  ];

  const data = {};
  _this.clients.forEach(async client => {
    const computer = client.computer;
    if (computer && computer.connection) {
      computer.services.forEach(service => {
        if (service.active) {
          // by time range
          const id = service.snapshot.id;
          const printer = computer.printers.find(element => element.id == id);
          let old = false;
          const row = {
            DT_RowId: id,
            time: moment.unix(printer.time.seconds),
            qrcode: service.qrcode,
            snapshot: service.snapshot,
            client: client.name,
            manufacturer: printer.manufacturer,
            model: printer.model,
            ip: service.ip,
            old
          };

          if (service.printer && service.printer.state)
            row.printer = service.printer;
          if (service.scanner && service.scanner.state)
            row.scanner = service.scanner;
          data[id] = row;
        }
      });
    }
  });
  _this.data = Object.values(data);

  $.each(_this.unique(_this.columns), (index, column) => {
    let title = column;
    let uniqueColumn = { name: column, data: column };
    let visible = true;
    let defaultContent = "";
    switch (column) {
      case "time":
        title = "time";
        visible = false;
        uniqueColumn["render"] = (data, type, row, meta) => {
          if (type !== "sort") {
            return data ? moment(data).fromNow() : "";
          }
          return data ? data : "";
        };
        break;
      case "client":
        visible = !_this.desktop;
        break;
      case "clients":
        title = "users";
        uniqueColumn["defaultContent"] = 0;
        break;
      case "total":
      case "black":
      case "color":
      case "prints":
      case "scans":
      case "copies":
        // case "credits":
        // case "cash":
        // case "card":
        uniqueColumn["defaultContent"] = 0;
        break;
      case "jobs":
        uniqueColumn["defaultContent"] = 0;
        uniqueColumn["name"] = "jobs";
        uniqueColumn["className"] = "defaultOrderBy";
        break;
      case "income":
        uniqueColumn["defaultContent"] = 0;
        uniqueColumn["type"] = "currency";
        uniqueColumn["render"] = income =>
          income
            ? income % 1 != 0
              ? `₪ ${Number(income).toFixed(2)}`
              : `₪ ${Number(income)}`
            : `₪ 0`;
        break;
      case "model":
        uniqueColumn["render"] = (data, type, row, meta) =>
          `${row.manufacturer || ""} ${row.model || ""}`;
        break;
      case "printer":
      case "scanner":
        let color = "red";
        uniqueColumn["render"] = json => {
          let data = "";
          if (json && json.state) {
            switch (json.state.toLowerCase()) {
              case "idle":
                color = "green";
                break;
              case "processing":
                color = "chocolate";
                break;
              case "stopped":
              case "offline":
                color = "red";
                break;
            }
            data = `<span style="color:${color};text-transform:capitalize">${json.state}</span>`;
            let reason;
            if (json.reason) {
              reason =
                typeof json.reason === "object"
                  ? (reason = json.reason.join(", "))
                  : json.reason;
              if (reason.toString().toLowerCase() != "none") {
                reason = reason
                  .toString()
                  .replace(/-/g, " ")
                  .split(/(?=[A-Z])/)
                  .join(" ")
                  .toLowerCase();
                data = `<span title="${reason}">${data}</span>`;
              }
            }
          }
          if (!data) data = defaultContent;
          return `${data}`;
        };
        break;
      case "qrcode":
        uniqueColumn["className"] = "button";
        uniqueColumn["orderable"] = false;
        uniqueColumn["render"] = data => {
          return `<button class="btn btn-secondary qrcode-button" style="border-radius: 7px;" data-qrcode="${data}">${_this.t(
            "QR Code"
          )}</button>`;
        };
        break;
    }
    uniqueColumn["title"] = _this.t(title);
    uniqueColumn["visible"] = visible;
    _this.uniqueColumns.push(uniqueColumn);
  });

  $("body").on("click", ".qrcode-button", e => {
    const code = e.target.dataset.qrcode;
    $("#qrcode-modal").modal("show");
    _this.$root.$children[0].$refs.qrcode.open(code);
  });

  const { columns, options } = _this.createTableProperties(_this);
  _this.table = $(_this.$el)
    .find("table")
    .DataTable(options);
  let fields, ajax, title;
  // fields = [
  //   {
  //     label: _this.t("Public"),
  //     name: "public",
  //     data: "public",
  //     type: "yesno",
  //     def: true
  //   }
  // ];
  ajax = (method, url, d, success, error) => {
    let output = { data: [] };
    switch (d.action) {
      // case "edit":
      //   async.eachOf(
      //     d.data,
      //     async (value, id, callback) => {
      //       const rowData = _this.table.row("#" + id).data();
      //       const serviceRef = rowData.snapshot.ref;
      //       await serviceRef.update(value);
      //       const data = $.extend({}, rowData, value);
      //       output.data.push(data);
      //       callback();
      //     },
      //     error => success(output)
      //   );
      //   break;
      case "remove":
        Object.keys(d.data).forEach(id => {
          const rowData = _this.table.row("#" + id).data();
          if (rowData.snapshot) {
            const serviceRef = rowData.snapshot.ref;
            serviceRef.get().then(snapshot => {
              const qrcode = snapshot.data().qrcode;
              _this.$store.state.db
                .collection("qrcodes")
                .doc(qrcode)
                .delete();
              serviceRef.delete();
            });
          }
        });
        success(output);
        break;
    }
  };
  const editor = _this.createEditor(_this, fields, ajax);
  let buttons1 = [];
  let buttons2 = [];
  buttons1 = [
    // {
    //   extend: "edit",
    //   editor: editor,
    //   text: '<span class="icon s7-pen"></span>',
    //   titleAttr: _this.t("Edit"),
    //   formTitle: (editor, dt) => editor.i18n.edit.title
    // },
    {
      extend: "remove",
      editor: editor,
      text: '<span class="icon s7-trash"></span>',
      titleAttr: _this.t("Remove")
    }
  ];
  _this.createButtons(_this, buttons1, buttons2);

  const tableId = _this.table
    .containers()[0]
    .getAttribute("id")
    .split("_")[2];

  $(`<div class="dt-buttons btn-group dt-header-buttons right">
            <div id="services-date-range" class="date-range" style="background: #fff; cursor: pointer; border: 1px solid #ccc; padding: 0 10px; padding-right: 6px;">
            <i class="icon s7-date"></i>&nbsp;
            <span></span> <i class="fa fa-caret-down"></i>
        </div>
    </div>`).prependTo(`#DataTables_Table_${tableId}_wrapper`);

  const servicesDateRangeCb = (start, end) => {
    $("#services-date-range span").html(
      start.format("ll") + " - " + end.format("ll")
    );
  };

  $("#services-date-range").daterangepicker(
    {
      startDate: _this.startDate,
      endDate: _this.endDate,
      ranges: _this.ranges,
      opens: "left"
    },
    servicesDateRangeCb
  );

  servicesDateRangeCb(_this.startDate, _this.endDate);

  const applyServiceRangeDate = async (startDate, endDate) => {
    _this.table.processing(true);
    const users = _this.clients.map(client => client.snapshot.id);
    const servicesResponse = await _this.serviceRequest("getServicesUsage", {
      users,
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD")
    });
    const services = _this.arrayToObject(servicesResponse, [
      "computer",
      "printer"
    ]);
    _this.table.data().map((value, index) => {
      const serviceId = `${value.snapshot.ref.parent.parent.id}/${value.DT_RowId}`;
      const service = services[serviceId];
      if (service) {
        delete service.user;
        delete service.printer;
        _this.table
          .row((idx, data) => data.DT_RowId === value.DT_RowId)
          .data(Object.assign(value, service));
      } else {
        _this.table
          .row((idx, data) => data.DT_RowId === value.DT_RowId)
          .data(
            Object.assign(value, {
              clients: 0,
              jobs: 0,
              total: 0,
              black: 0,
              color: 0,
              prints: 0,
              copies: 0,
              scans: 0,
              // credits: 0,
              income: 0
            })
          );
      }
    });
    _this.table
      .column("total:name")
      .order("desc")
      .draw();
    _this.table.processing(false);
  };

  $("#services-date-range").on("apply.daterangepicker", (event, picker) => {
    event.preventDefault();
    const { startDate, endDate } = picker;
    applyServiceRangeDate(startDate, endDate);
  });

  applyServiceRangeDate(_this.startDate, _this.endDate);
};



// WEBPACK FOOTER //
// ./src/mixins/Managed.js